import React from 'react';
import { NewExistingType } from '../../../types';

export type NewExistingValue = NewExistingType | null;

interface NewExistingSegmentProps {
  value: NewExistingValue;
  onChange: (value: NewExistingValue) => void;
  disabled?: boolean;
}

export const NewExistingSegment: React.FC<NewExistingSegmentProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div className="inline-flex items-center ml-2">
      <div className="inline-flex items-center rounded-full bg-slate-100/80 p-0.5" role="group">
        <button
          type="button"
          onClick={() => onChange(NewExistingType.NEW)}
          disabled={disabled}
          className={`px-2 py-1 text-[10px] 3xl:text-xs font-semibold rounded-full transition-all duration-200 ${
            value === NewExistingType.NEW
              ? 'bg-amber-500 text-white shadow-sm'
              : 'text-slate-500 hover:text-slate-700'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          New
        </button>
        <button
          type="button"
          onClick={() => onChange(NewExistingType.EXISTING)}
          disabled={disabled}
          className={`px-2 py-1 text-[10px] 3xl:text-xs font-semibold rounded-full transition-all duration-200 ${
            value === NewExistingType.EXISTING
              ? 'bg-amber-500 text-white shadow-sm'
              : 'text-slate-500 hover:text-slate-700'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          Existing
        </button>
      </div>
    </div>
  );
};
